/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Take_AllInputs */

const vi_lot_items_take_all = /** @type {(inputs: Lot_Items_Take_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy hết`)
};

/**

* @param {Lot_Items_Take_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_take_all = /** @type {((inputs?: Lot_Items_Take_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Take_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_take_all(inputs)
});